import React, { Component, createRef } from "react";
import { fabric } from "fabric";
import Remove from "..//Dashboard/icon/x-lg.svg";
import Circle from "..//Dashboard/icon/circle.svg";
import Edit from "..//Dashboard/icon/pencil-fill.svg";
import Undo from "..//Dashboard/icon/undo.svg";
import Axios from "axios";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { Button, FormGroup, Input, Modal, ModalBody, Spinner } from "reactstrap";
import "./fabricImgEdition.css";
import { Link } from "react-router-dom";
import { Card, CardHeader, Col } from "reactstrap";
import DentEditorTable from "./DentEditorTable";
import { data } from "jquery";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
let Posleft,
  Postop,
  damage_arr = [];

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class DentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canvas: "",
      option: "",
      prePopulatePartName: this.props.history.location.pathname
        .split("/")[2]
        .split("_")[1],
      partName: this.props.history.location.pathname.split("/")[2],
      zoom: false,
      selection: true,
      strokeWidth: 1.5,
      textColor: "green",
      strokeColor: "#FF0000",
      fontSize: 10,
      words: {},
      lang: "gb",
      userEnteredDents: [],
      dents: [],
      dentsOption: ["D-Green", "N-Yellow", "Q-Orange"],
      sizeOption: ["0-10mm", "11-25mm", "26-35mm"],
      dentType: "D-Green",
      dentSize: (localStorage.getItem("client") == "US" || localStorage.getItem("client") == "CANADA") ? 12 : 14,
      dentsCount: 0,
      isUpdate: false,
      selectedObjIndex: -1,
      diameter: 20,
      isPlasticTrue: false,
      order: {
        vinNumber: "",
        orderNumber: Math.round(Math.random() * 100000000),
        issuedOn: new Date(),
      },
      originalDents: 0,
      data64ImgError : false,
      data64Url : "",
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
      blindColor: "#000000",
      originalWidth: 0,
    originalHeight: 0,
    is_remove_x: false,
      // dentPos : [],
      // imageDimensions : {}
    };
    this.cnavasRef = createRef();
  }
  initCanvas() {
    return new fabric.Canvas("canvas", {
      height: this.cnavasRef.current.clientHeight,
      width: this.cnavasRef.current.clientWidth,
      allowTouchScrolling: false,
      centeredScaling: true,
    });
  }

  componentDidMount = async () => {
    this.setState({
      canvas: this.initCanvas(),
    }, async () => {
      await this.getLang();
      await this.getData();
      await this.getPartDetails();
      await this.getBase64Url();
      await this.getFallbackDetails();
      // await this.handleGetImageDimensions();
      // this.dentPlots();
      this.setdentsOption();
    });
  }
  setdentsOption = () => {
    const client = localStorage.getItem("client");
    if (client === "US") {
      this.setState({
        dentsOption: ["D-Green", "N-Yellow", "Q-Orange", "H-Pink", "O-Red"],
      });
    } else if (client === "CANADA" || client === "FR") {
      this.setState({
        dentsOption: ["D-Green", "N-Yellow", "Q-Orange", "H-Pink"],
      });
    } else {
      this.setState({
        dentsOption: ["D-Green", "N-Yellow", "Q-Orange"],
      });
    }
  };
  
  handleGetImageDimensions = async () => {
    const imageUrl = this.props.location.state ? this.props.location.state.imageUrl : this.state.data64Url;
    const dimensions = await this.getImageDimensions(imageUrl);
    this.setState({ imageDimensions: dimensions });
  }

  dentPlots = () => {
    const { dentPos, imageDimensions, canvas } = this.state;
    const { imageIndex } = this.props.location.state;
    
    if (!canvas || !imageDimensions) return;
    
    const createCircle = (x, y, radius, color) => {
      return new fabric.Circle({
        left: x - radius / 2,
        top: y - radius / 2,
        radius: radius / 2,
        fill: 'transparent',
        stroke: color,
        strokeWidth: 2,
        selectable: true,
      });
    };

    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();
    const originalImageWidth = imageDimensions.width;
    const originalImageHeight = imageDimensions.height;

   Array.isArray(dentPos) && dentPos.length > 0 && dentPos.forEach((dent) => {
      const { X, Y, DiaPx, Color } = dent;
      const x = Array.isArray(X) ? X[imageIndex] : X 
      const y = Array.isArray(Y) ? Y[imageIndex] : Y 
      const radius = Array.isArray(DiaPx) ? DiaPx[imageIndex] : DiaPx 
      const scaledX = x * (canvasWidth / originalImageWidth);
      const scaledY = y * (canvasHeight / originalImageHeight);
      const scaledRadius = radius * (canvasWidth / originalImageWidth);

      const circle = createCircle(scaledX, scaledY, scaledRadius, Color.toLowerCase() === 'lime green' ? '#32CD32' : Color);
      canvas.add(circle);
    })

    canvas.renderAll();
  }

   setBg = () => {
    const {canvas} = this.state;
    let canvasHeight, canvasWidth
    fabric.Image.fromURL(
      this.props.data64Url ? this.props.data64Url : this.state.data64Url,
      (img) => {
        const originalWidth = img.width * img.scaleX;
        const originalHeight = img.height * img.scaleY;
  
        // Store original dimensions only if not already set
        if (!this.state.originalWidth && !this.state.originalHeight) {
          this.setState({
            originalWidth,
            originalHeight,
          });
        }
        // if ((img.width <= 4297 && img.width >= 1644) || img.height >= 2157) {
          img.scaleX = 1;
          img.scaleY = 1;
        // } else 
        canvasWidth = img.width * img.scaleX;
          canvasHeight = img.height * img.scaleY;
        canvas.setHeight(canvasHeight);
        canvas.setWidth(canvasWidth);
        // var canvasContainer = document.getElementsByClassName("canvas-container");
        // canvasContainer[0].style.overflow = "scroll";
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
        });
  
        canvas.renderAll();
      }
    );
  };

  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);
      if (res.data) {
       this.setState({
        is_remove_x: parseInt(res && res.data && res.data.is_remove_x) === 1 ? true : false,
       })
      }
    } catch (error) {
      
    }
  };
  
  // setBg = () => {
  //   let canvasHeight, canvasWidth;
  //   let prePopulatePartName = this.state.prePopulatePartName;
  //   fabric.Image.fromURL(
  //     this.props.location.state
  //       ? this.props.location.state.imageUrl
  //       : this.state.data64Url,
  //     function (img, isError) {
  //       const originalWidth = img.width * img.scaleX;
  //       const originalHeight = img.height * img.scaleY;

  //       if (!this.state.originalWidth && !this.state.originalHeight) {
  //         this.setState({
  //           originalWidth,
  //           originalHeight,
  //         });
  //       }
  //       //scale img if its too large
  //       if ((img.width <= 4297 && img.width >= 1644) || img.height >= 2157) {
  //         img.scaleX = 0.4;
  //         img.scaleY = 0.4;
  //       }
  //       canvasWidth = img.width * img.scaleX;
  //       canvasHeight = img.height * img.scaleY;
  //       canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {});
  //     }
  //   );
  //   setTimeout(() => {
  //     canvas.setHeight(canvasHeight);
  //     canvas.setWidth(canvasWidth);
  //   }, 100);
  // };

  componentDidUpdate(prevProps, prevState) {
    //return if canvas is not created yet
    const {
      option,
      // brushColor,
      // brushWidth,
      fontSize,
      selection,
      strokeColor,
      strokeWidth,
      textColor,
      canvas,
      dents,
      diameter,
      dentType,
      dentsCount,
      dentSize,
      originalDents,
      A,
      B,
      C,
      is_remove_x
    } = this.state;

    if (!canvas) {
      return;
    }
    
    canvas.off('mouse:dblclick');

  // Add double-click event listener for circle deletion
  canvas.on('mouse:dblclick', (options) => {
    const target = options.target;
    if (target && target.type === 'circle') {
      canvas.remove(target);
      canvas.renderAll();
      // Handle state updates or other logic as needed
    }
  });

    //default text on canvas
    const getText = (origX, origY, Txt, myId, color) => {
      let text = new fabric.IText(Txt, {
        left: origX,
        top: origY - 12,
        originX: "left",
        originY: "top",
        fontSize: "0px",
        // fill: color ? color : textColor,
        fill: "#FFFFFF",
        id: myId,
      });
      text.set({ textType: "objText"});
      canvas.add(text);
    };
    // canvas.on("mouse:dblclick", (e) => {
    //       const {canvas , dents} = this.state
    //       var target = canvas.findTarget(e);
    //       dents && dents.map((obj,i) => {
    //         if(obj.id === target.id){
    //           this.setState({
    //             dentSize: obj.dentSize,
    //             dentType : obj.dentType,
    //             selectedObjIndex : i,
    //             isUpdate : true
    //           })
    //         }
    //   })
    // }
    // )
    // canvas.off("mouse:dblclick")
    // generate 5 alphabet random
    const makeid = (length) => {
      let id = "";
      let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        id += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return id;
    };
    // const setBg = () => {
    //   let canvasHeight, canvasWidth;
    //   let prePopulatePartName = this.state.prePopulatePartName;
    //   fabric.Image.fromURL(
    //     this.props.location.state
    //       ? this.props.location.state.imageUrl
    //       : this.state.data64Url,
    //     function (img, isError) {
    //       //scale img if its too large
    //       if ((img.width <= 4297 && img.width >= 1644) || img.height >= 2157) {
    //         img.scaleX = 0.4;
    //         img.scaleY = 0.4;
    //       }
    //       canvasWidth = img.width * img.scaleX;
    //       canvasHeight = img.height * img.scaleY;
    //       canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {});
    //     }
    //   );
    //   setTimeout(() => {
    //     canvas.setHeight(canvasHeight);
    //     canvas.setWidth(canvasWidth);
    //   }, 100);
    // };
   

    
    
    if (
      prevProps.data64Url !== this.props.data64Url ||
      prevState.data64Url !== this.state.data64Url
    ) {
      this.setBg();
    }
    canvas.off("mouse:down").off("mouse:move").off("mouse:up");
    //for delete key
    // window.addEventListener("keyup", ({ key }) => {
    //     if (key === "Delete") {
    //       this.handleDelete();
    //     }
    //   });
    //if the option is zoom
    if (option === "zoom") {
      canvas.isDrawingMode = false;
      canvas.off("mouse:down").off("mouse:move").off("mouse:up");
      return;
    }
    // if(option === 'move'){
    //   canvas.getActiveObject() && canvas.getObjects().forEach(function(o) {
    //     if(o.id === canvas.getActiveObject().id) {
    //       canvas.setActiveObject(o);
    //     }
    //   })
    //   canvas.renderAll();
    // }
    var isDown;
    if (option === "circle") {
      // #BD5B63 = salmon color
      let drawCircle, isDown, origX, origY, Txt, circleColor;
      if (dentType === "D-Green") {
        circleColor = "#32CD32";
      } else if (dentType === "N-Yellow") {
        circleColor = "#FFFF00";
      } else if (dentType === "Q-Orange") {
        if (localStorage.getItem("client") == "FR" || localStorage.getItem("client") == "CANADA" || localStorage.getItem("client") == "US") {
          circleColor = "#CB8A01";
        } else {
          circleColor = "#FF0000";
        }
      } else if (dentType === "H-Pink") {
        if (localStorage.getItem("client") == "FR" || localStorage.getItem("client") == "CANADA") {
          circleColor = "#FF0000";
        } else {
          circleColor = "#BD5B63";
        }
      } else {
        circleColor = "#FF0000";
      }
      var TotalDents = originalDents + dents.length + 1;
      let myId = makeid(5);
      //turning off previous events
      // canvas.isDrawingMode = false;
      canvas.off("mouse:down").off("mouse:move").off("mouse:up");
      //start drawing
      canvas.on("mouse:down", function (o) {
        isDown = true;
        var pointer = canvas.getPointer(o.e);
        origX = pointer.x - dentSize / 2;
        origY = pointer.y - dentSize / 2;
        Txt = TotalDents.toString();
        drawCircle = new fabric.Circle({
          left: origX,
          top: origY,
          // originX: "left",
          // originY: "top",
          // radius: pointer.x - origX ? pointer.x - origX : 30,
          radius: dentSize / 2,
          fill: "",
          stroke: circleColor,
          strokeWidth: parseInt(strokeWidth),
          padding: 0,
        });
        drawCircle.set({ id: myId });
        drawCircle.set({ dentType: dentType });
        Posleft = origX;
        Postop = origY;
        canvas.add(drawCircle);
        getText(origX + drawCircle.radius,origY,Txt,myId);

        drawCircle.selectable = selection;
        // let text = new fabric.IText("Add text ", {
        //   left: origX,
        //   top: origY-30,
        //   originX: "left",
        //   originY: "top",
        //   fontSize: fontSize,
        //   fill: textColor,
        // });
        // canvas.add(text);
      });
      canvas.on("mouse:move", function (o) {
        // if (!isDown) return;
        // var pointer = canvas.getPointer(o.e);
        // var radius =
        //   Math.max(Math.abs(origY - pointer.y), Math.abs(origX - pointer.x)) /
        //   2;

        // if (radius > drawCircle.strokeWidth) {
        //   radius -= drawCircle.strokeWidth / 2;
        // }
        // // if radius is less then 10 set default 10
        // if (radius < 10) {
        //   radius = 10;
        // }
        // drawCircle.set({ radius: radius });
        // if (origX > pointer.x) {
        //   drawCircle.set({ originX: "right" });
        // } else {
        //   drawCircle.set({ originX: "left" });
        // }
        // if (origY > pointer.y) {
        //   drawCircle.set({ originY: "bottom" });
        // } else {
        //   drawCircle.set({ originY: "top" });
        // }
        // drawCircle.set({ id: myId });
        canvas.renderAll();
      });
      //end drawing
      canvas.on("mouse:up", async (o) => {
        isDown = false;
        canvas.off("mouse:down").off("mouse:move").off("mouse:up");
        await this.state.canvas.discardActiveObject().renderAll();
        drawCircle &&
          drawCircle.on("mousedblclick", (e) => this.handleObjSelect(e));
        // getText(origX + drawCircle.radius, origY, Txt, myId, circleColor);
        let obj = {
          id: myId,
          dentType: this.state.dentType,
          dentSize: this.state.dentSize,
        };
        dents.push(obj);
        if (dentType === "D-Green") {
          this.setState({
            A: this.state.A + 1,
          });
        } else if (dentType === "N-Yellow") {
          this.setState({
            B: this.state.B + 1,
          });
        } else if (dentType === "Q-Orange") {
          this.setState({
            C: this.state.C + 1,
          });
        } else if (dentType === "H-Pink") {
          this.setState({
            D: this.state.D + 1,
          });
        } else if (dentType === "O-Red") {
          this.setState({
            E: this.state.E + 1,
          });
        }
        this.setState({
          dents,
          dentsCount: this.state.dentsCount + 1,
        });
      });
    } 
    else if (option === "Remove") {
      if (dentsCount <= 0) {
        this.setState({
          option: "",
        });
      }
      canvas.off("mouse:down").off("mouse:move").off("mouse:up");
      let Remove,
        origX,
        origY,
        totalCount = this.state.dentsCount;
        let selectedDents
        if (this.state.dentType == "D-Green") {
          selectedDents = "A";
        }
        else if (this.state.dentType == "N-Yellow") {
          selectedDents = "B";
        }
        else if (this.state.dentType == "Q-Orange") {
          selectedDents = "C";
        }
        else if (this.state.dentType == "H-Pink") {
          selectedDents = "D";
        }
        else if (this.state.dentType == "O-Red") {
          selectedDents = "E";
        }
      let updatedDents = this.state[selectedDents] - 1;
      //start drawing
      const client = localStorage.getItem("client");
      canvas.on("mouse:down", function (o) {
        if(is_remove_x && client == "POLAND") {
          if (updatedDents < 0) {
            Toast.fire({
            type: "warning",
            title: "No dents available for selected dent type",
          });
          return;
        }
      } else if (client !== "POLAND"){
        if (updatedDents < 0) {
            Toast.fire({
            type: "warning",
            title: "No dents available for selected dent type",
          });
        }
      }
        var pointer = canvas.getPointer(o.e);
        // origX = pointer.x;
        // origY = pointer.y;
        // for set X center of circle
        origX =
          canvas.getActiveObject() &&
          canvas.getActiveObject().getCenterPoint() !== undefined
            ? canvas.getActiveObject().getCenterPoint().x
            : pointer.x;
        origY =
          canvas.getActiveObject() &&
          canvas.getActiveObject().getCenterPoint() !== undefined
            ? canvas.getActiveObject().getCenterPoint().y
            : pointer.y;
        // if(canvas.getActiveObject() && canvas.getActiveObject().getCenterPoint() !== undefined) {

        Remove = new fabric.Textbox("X", {
          left: origX,
          top: origY,
          originX: "center",
          originY: "center",
          // size based on object radius
          // fontSize: o.target ? o.target.radius * 3 : "20",
          fontSize: "20",
          // fill: canvas.getActiveObject()
          // ? canvas.getActiveObject().stroke
          // : "red",
          fill: "#F00000",
          editable: false,
          id: canvas.getActiveObject()
            ? canvas.getActiveObject().id
            : makeid(5),
           
        });
        Remove.set({ textType: "modal" , dentType : dentType });
        totalCount -= 1;
        canvas.add(Remove);
        // }
      });
      // moving event of object
      // canvas.on('object:moving',(o) => {
      //   var newgroup = new fabric.Group();
      //   let ObjectName = o.target.id
      //   canvas.getObjects().forEach(function(o) {
      //     if(o.id === ObjectName) {
      //         // canvas.setActiveObject(o.id);
      //         newgroup.add(o);
      //         // obj2.left = obj1.left + 50;
      //         // obj2.top = obj1.top;
      //     }
      //   })
      //   canvas.add(newgroup)
      //   // canvas.setActiveGroup(newgroup);
      //   canvas.renderAll();
      // })
      canvas.on("mouse:up", (o) => {
        if (updatedDents < 0) {
          return;
        }
        let updatedState = {};
        isDown = false;
        canvas.off("mouse:down").off("mouse:move").off("mouse:up");

        let activeObject = canvas.getActiveObject();

        // Check the stroke condition
        if (activeObject) {
          switch (activeObject.stroke) {
            case "#32CD32": //green
            this.setState({dentType : "D-Green"},()=>{})
              updatedState = { A: this.state.A - 1 };
              break;
            case "#FFFF00": //yellow
            this.setState({dentType : "N-Yellow"})
              updatedState = { B: this.state.B - 1 };
              break;
            case "#CB8A01": //orange
            this.setState({dentType : "Q-Orange"})
              updatedState = { C: this.state.C - 1 };
              break;
            case "#BD5B63": //selmon/pink
            this.setState({dentType : "H-Pink"})
              updatedState = { D: this.state.D - 1 };
              break;
            case "#FF0000": //red
              if (localStorage.getItem("client") == "FR" || localStorage.getItem("client") == "CANADA") {
                this.setState({dentType : "H-Pink"})
                updatedState = { D: this.state.D - 1 };
              } else if(localStorage.getItem("client") == "US") {
                this.setState({dentType : "O-Red"})
                updatedState = { E: this.state.E - 1 };
              } else {
                this.setState({dentType : "Q-Orange"})
                updatedState = { C: this.state.C - 1 };
              }
              break;
            default:
              updatedState[selectedDents] = updatedDents;
              break;
          }
        } else {
          updatedState[selectedDents] = updatedDents;
        }

        if(is_remove_x && client == "POLAND"){
          this.setState({
            dentsCount: totalCount,
            ...updatedState,
          });
        } else if(client !== "POLAND") {
          this.setState({
            dentsCount: totalCount,
            ...updatedState,
          });
        } else {
          this.setState({
            // dentsCount: totalCount,
            // ...updatedState,
          });
        }

        canvas.discardActiveObject().renderAll();
      });
    } 
    else if (option === "blind") {
      let drawBlindCircle, isDown, origX, origY, circleColor;
      circleColor = this.state.blindColor;
      let myId = makeid(5);

      canvas.off("mouse:down").off("mouse:move").off("mouse:up");

      // Start drawing when the mouse is clicked
      canvas.on("mouse:down", function (o) {
        isDown = true;
        var pointer = canvas.getPointer(o.e);
        origX = pointer.x - dentSize / 2;
        origY = pointer.y - dentSize / 2;
        drawBlindCircle = new fabric.Circle({
          left: origX,
          top: origY,
          radius: dentSize / 2,
          fill: circleColor,
          stroke: circleColor,
          strokeWidth: parseInt(strokeWidth),
          padding: 0,
        });

        drawBlindCircle.set({ id: myId });
        drawBlindCircle.set({ dentType: dentType });

        Posleft = origX;
        Postop = origY;
        canvas.add(drawBlindCircle);
        // drawBlindCircle.selectable = selection;
      });

      canvas.on("mouse:move", function (o) {
        canvas.renderAll();
      });

      drawBlindCircle = new fabric.Circle({
        left: origX,
        top: origY,
        radius: dentSize / 2,
        fill: circleColor,
        stroke: circleColor,
        strokeWidth: parseInt(strokeWidth),
        padding: 0,
      });

      drawBlindCircle.set({ id: myId });
      drawBlindCircle.set({ dentType: dentType });

      Posleft = origX;
      Postop = origY;
      canvas.add(drawBlindCircle);
      drawBlindCircle.selectable = false;
      drawBlindCircle.lockMovementX = true;
      drawBlindCircle.lockMovementY = true;
      drawBlindCircle.lockScalingX = true;
      drawBlindCircle.lockScalingY = true;
    }
  }

  // dentPlots = () => {
  //   const { dentPos, imageUrl, imageDimensions, canvas } = this.state;
  //   const getIndex = imageUrl.split("_")[imageUrl.split("_").length - 1]

  //   if (!canvas || !imageDimensions) return;
    
  //   const createCircle = (x, y, radius, color) => {
  //     return new fabric.Circle({
  //       left: x - radius / 2,
  //       top: y - radius / 2,
  //       radius: radius / 2,
  //       fill: 'transparent',
  //       stroke: color,
  //       strokeWidth: 2,
  //       selectable: true,
  //     });
  //   };

  //   const canvasWidth = canvas.getWidth();
  //   const canvasHeight = canvas.getHeight();
  //   const originalImageWidth = imageDimensions.width;
  //   const originalImageHeight = imageDimensions.height;

  //  Array.isArray(dentPos) && dentPos.length > 0 && dentPos.forEach((dent) => {
  //     const { X, Y, DiaPx, Color } = dent;
  //     const x = Array.isArray(X) ? X[this.props.location.state.imageIndex ? this.props.location.state.imageIndex : getIndex - 1] : X 
  //     const y = Array.isArray(Y) ? Y[this.props.location.state.imageIndex ? this.props.location.state.imageIndex : getIndex - 1] : Y 
  //     const radius = Array.isArray(DiaPx) ? DiaPx[this.props.location.state.imageIndex ? this.props.location.state.imageIndex : getIndex - 1] : DiaPx 

  //     console.log(x,y,radius);
      
  //     const scaledX = x * (canvasWidth / originalImageWidth);
  //     const scaledY = y * (canvasHeight / originalImageHeight);
  //     const scaledRadius = radius * (canvasWidth / originalImageWidth);

  //     const circle = createCircle(scaledX, scaledY, scaledRadius, Color.toLowerCase() === 'lime green' ? '#32CD32' : Color);
  //     canvas.add(circle);
  //   })

  //   canvas.renderAll();
  // }
  // setCanvasBackground = () => {
  //   const { canvas } = this.state;
  //   let canvasHeight, canvasWidth;
  
  //   fabric.Image.fromURL(
  //     this.props.location.state ? this.props.location.state.imageUrl : this.state.data64Url,
  //     function (img, isError) {
  //       if ((img.width <= 4297 && img.width >= 1644) || img.height >= 2157) {
  //         img.scaleX = 0.4;
  //         img.scaleY = 0.4;
  //       }
  //       canvasWidth = img.width * img.scaleX;
  //       canvasHeight = img.height * img.scaleY;
  //       canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {});
  //     }
  //   );
  
  //   setTimeout(() => {
  //     canvas.setHeight(canvasHeight);
  //     canvas.setWidth(canvasWidth);
  //   }, 100);
  // };
  
  // handleCanvasOptions = () => {
  //   const { option, dentType, dentSize, fontSize, selection, strokeWidth, canvas,originalDents,dents,A,B,C } = this.state;
  
  //   canvas.off("mouse:down").off("mouse:move").off("mouse:up");
  
  //   if (option === "circle") {
  //     let drawCircle, isDown, origX, origY, Txt, circleColor;
  
  //     if (dentType === "A") {
  //       circleColor = "#32CD32";
  //     } else if (dentType === "B") {
  //       circleColor = "#FFFF00";
  //     } else {
  //       circleColor = "#FF0000";
  //     }
  
  //     let myId = this.makeid(5);
  
  //     canvas.on("mouse:down", (o) => {
  //       isDown = true;
  //       var pointer = canvas.getPointer(o.e);
  //       origX = pointer.x - dentSize / 2;
  //       origY = pointer.y - dentSize / 2;
  //       Txt = (originalDents + dents.length + 1).toString();
  
  //       drawCircle = new fabric.Circle({
  //         left: origX,
  //         top: origY,
  //         radius: dentSize / 2,
  //         fill: "",
  //         stroke: circleColor,
  //         strokeWidth: parseInt(strokeWidth),
  //         padding: 0,
  //       });
  //       drawCircle.set({ id: myId });
  //       drawCircle.set({ dentType });
  //       canvas.add(drawCircle);
  
  //       drawCircle.selectable = selection;
  //     });
  
  //     canvas.on("mouse:up", async () => {
  //       isDown = false;
  //       canvas.off("mouse:down").off("mouse:move").off("mouse:up");
  //       await canvas.discardActiveObject().renderAll();
  //       drawCircle.on("mousedblclick", (e) => this.handleObjSelect(e));
  //       this.getText(origX + drawCircle.radius, origY, Txt, myId, circleColor);
  
  //       let obj = {
  //         id: myId,
  //         dentType,
  //         dentSize,
  //       };
  //       dents.push(obj);
  //       this.setState({
  //         dents,
  //         dentsCount: dents.length,
  //         A: dentType === "A" ? A + 1 : A,
  //         B: dentType === "B" ? B + 1 : B,
  //         C: dentType === "C" ? C + 1 : C,
  //       });
  //     });
  
  //   } else if (option === "Remove") {
  //     // Handle Remove option
  //   } else if (option === "blind") {
  //     // Handle blind option
  //   }
  // };
  
  // createCircle = (x, y, radius, color) => {
  //   console.log(x, y, radius, color);
  //   return new fabric.Circle({
  //     left: x - radius / 2,
  //     top: y - radius / 2,
  //     radius: radius / 2,
  //     fill: 'transparent',
  //     stroke: color,
  //     strokeWidth: 2,
  //     selectable: true,
  //   });
  // };
  
  // getImageDimensions = (imageUrl) => {
  //   return new Promise((resolve, reject) => {
  //     fabric.Image.fromURL(imageUrl, function (img) {
  //       resolve({ width: img.width, height: img.height });
  //     }, null, { crossOrigin: 'anonymous' });
  //   });
  // };
  
  // makeid = (length) => {
  //   let id = "";
  //   let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   let charactersLength = characters.length;
  //   for (var i = 0; i < length; i++) {
  //     id += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return id;
  // };
  
  // getText = (origX, origY, Txt, myId, color) => {
  //   const { fontSize, canvas } = this.state;
  //   let text = new fabric.IText(Txt, {
  //     left: origX,
  //     top: origY - 12,
  //     originX: "left",
  //     originY: "top",
  //     fontSize: fontSize,
  //     fill: "#FFFFFF",
  //     id: myId,
  //   });
  //   text.set({ textType: "objText" });
  //   canvas.add(text);
  // };
  
  // handleObjSelect = (e) => {
  //   const { canvas, dents } = this.state;
  //   var target = canvas.findTarget(e);
  //   dents.map((obj, i) => {
  //     if (obj.id === target.id) {
  //       this.setState({
  //         dentSize: obj.dentSize,
  //         dentType: obj.dentType,
  //         selectedObjIndex: i,
  //         isUpdate: true,
  //       });
  //     }
  //   });
  // };
  

  handleObjSelect = (e) => {
    if (e === undefined) {
      return;
    }
    // function call when select object
    const { canvas, dents } = this.state;
    var target = canvas.findTarget(e);
    dents &&
      dents.map((obj, i) => {
        if (obj.id === target.id) {
          this.setState({
            dentSize: obj.dentSize,
            dentType: obj.dentType,
            selectedObjIndex: i,
            isUpdate: true,
          });
        }
      });
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  // for delete Objects
  // handleDelete() {
  //   const {dents} =this.state
  //   this.setState({
  //       option : ""
  //   })
  //   //getting all selected objects
  //   var activeGroup = this.state.canvas.getActiveObjects();
  //   if (activeGroup) {
  //     let delCount = 0;
  //     for (let i in activeGroup) {
  //       if(dents.length && activeGroup[i].id === dents[dents.length-1].id) {
  //         this.state.canvas.remove(activeGroup[i]);
  //         // this.state.canvas.remove(activeGroup[i]);
  //         if (activeGroup[i].get("type") !== "i-text") {
  //           this.delete(activeGroup[0].id)
  //         }else{
  //           this.delete(activeGroup[i].id)
  //         }
  //       }else if(activeGroup[i].get("type") == "textbox" && activeGroup[i].get("textType") === 'modal') {
  //         this.state.canvas.remove(activeGroup[i]);
  //         this.setState({
  //           dentsCount : this.state.dentsCount + 1
  //         })
  //       }
  //       else if(activeGroup[i].get("type") == "i-text" && activeGroup[i].get("textType") === 'modal') {
  //         this.state.canvas.remove(activeGroup[i]);
  //       } else {
  //         return
  //       }
  //     }
  //     this.state.canvas.discardActiveObject();
  //     this.state.canvas.renderAll();
  //   } else {
  //     const type = this.state.canvas.getActiveObject().get("type");
  //     this.state.canvas.getActiveObject().remove();
  //     this.handleDelete(type,1)
  //     this.delete(activeGroup[0].id)
  //   }
  // }
  // delete = (id) => {
  //     const {dents,canvas} = this.state
  //     dents.map((obj,i) => {
  //       if(obj.id === id) {
  //         dents.splice(i, 1);
  //       }
  //     })
  //     canvas.getObjects().forEach(function(o) {
  //       if(o.id === id) {
  //           canvas.remove(o);
  //       }
  //   });
  //     this.setState({dents})
  //     // this.state.dentsCount -= 1;
  // }
  handleClear() {
    var allObjs = this.state.canvas.getObjects();
    if (allObjs) {
      let delCount = 0;
      for (let i in allObjs) {
        this.delete(allObjs[i].id);
        this.state.canvas.remove(allObjs[i]);
        if (allObjs[i].get("type") !== "i-text") {
          delCount += 1;
        }
      }
      this.setState({
        dentsCount: 0,
      });
      this.handleClearCanvas();
      this.state.canvas.renderAll();
    }
  }
  handleClearCanvas = () => {
    this.setState({
      dentsCount: 0,
    });
  };
  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    this.customerInfo();
  };
  // return image name without jpg extention if it already has name in it
  imageName = () => {
    if (this.state.partName.includes(".jpg")) {
      return this.state.partName;
    } else {
      return `${this.state.partName}.jpg`;
    }
  };
  getData = async () => {
    const client = localStorage.getItem("client");
    Axios.get(
      `${configuration.getData}?vin=${localStorage.getItem(
        "selectedFile"
      )}&partnerId=${localStorage.getItem("partnerId")}`
    )
      .then((r) => {
        this.setState(
          {
            data: r.data,
            clientName: r.data.Client,
          },
          () => {
            r.data &&
              r.data.Dents &&
              r.data.Dents.map((obj) => {
                if(this.state.prePopulatePartName === "TrunkCover" && obj.Part === this.state.prePopulatePartName && (client === "SWISS" || client === "POLAND")) {
                  let trunkObj = r.data.Dents.filter((obj) => obj.Part === 'Trunk')[0];
                  this.setState({
                    // AvgDiaMm: obj.AvgDiaMm ? obj.AvgDiaMm : 20,
                    // dentsCount: obj.TotalDents,
                    originalDents: obj.OriginalDents || 0,
                    dents: obj.userEnteredDents || [],
                    A : obj.A + trunkObj.A || 0,
                    B : obj.B + trunkObj.B || 0,
                    C : (obj.C || 0) + trunkObj.C || 0,
                    // dentPos : obj.DentPos || [],
                    isPlasticTrue: obj.Plastic,
                  },() => {
                    this.setState({
                      dentsCount: this.state.A + this.state.B + (this.state.C ||0 )
                    })
                  });
                }else if (obj.Part === this.state.prePopulatePartName) {
                  this.setState({
                    // AvgDiaMm: obj.AvgDiaMm ? obj.AvgDiaMm : 20,
                    dentsCount: obj.TotalDents,
                    originalDents: obj.OriginalDents || 0,
                    dents: obj.userEnteredDents || [],
                    // dentPos : obj.DentPos || [],
                    isPlasticTrue: obj.Plastic,
                  });
                  if (
                    client === "OTHER" ||
                    client === "SWISS" ||
                    client === "POLAND" ||
                    client === "CANADA" ||
                    client === "US" ||
                    client === "ROM" ||
                    client === "FR"
                  ) {
                    this.setState({
                      A: obj.A,
                      B: obj.B,
                      C: obj.C,
                      D: obj.D,
                      E: obj.E,
                      isPlasticTrue: obj.Plastic,
                    });
                  } else if (client === "DNS") {
                    this.setState({
                      A: obj.A,
                      isPlasticTrue: obj.Plastic,
                    });
                  }
                }
              });
          }
        );
        // if(r.data && r.data.userEnteredDamages.length){
        //     this.setState({
        //         userEnteredDamages : r.data.userEnteredDamages ? r.data.userEnteredDamages : [],

        //     },() => {
        //         this.state.userEnteredDamages.length && this.state.userEnteredDamages.map((obj) => {
        //             if(obj.part === this.state.prePopulatePartName) {
        //                 this.setState({
        //                   dents : obj.dents
        //                 })
        //             }
        //         })
        //     })
        // }
      })
      .catch((error) => alert("An error occured please try again"));
  };

  getPartData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(`${configuration.getData}?vin=${vin}&partnerId=${partnerId}`)
      .then((r) => {
        //  console.table(r.data.Dents[0].DentPos);
        if (r.data) {
          this.setState({ data: r.data });
          const finalPartData = r.data.Dents.filter(
            (r) => r.Part == this.state.prePopulatePartName
          )[0];
          this.setState({
            A: finalPartData.A,
            B: finalPartData.B,
            C: finalPartData.C,
          });
          if (finalPartData.Size_of_damage_A !== "") {
            this.setState({
              Size_of_damage_A: finalPartData.Size_of_damage_A,
            });
          }
          if (finalPartData.Size_of_damage_B !== "") {
            this.setState({
              Size_of_damage_B: finalPartData.Size_of_damage_B,
            });
          }
          if (finalPartData.Size_of_damage_C !== "") {
            this.setState({
              Size_of_damage_C: finalPartData.Size_of_damage_C,
            });
          }
          if (finalPartData.Comment !== "") {
            this.setState({
              prepopulateComment: finalPartData.Comment,
            });
          }
        } else {
          alert("Something went wrong");
        }
        this.setState({
          loading: false,
        });
      })
      .catch((error) => this.setState({ loading: false }));
  };
  updateUserEnteredDents = () => {
    const dentsData = this.state.userEnteredDents;
    let index;
    if (dentsData.length) {
      let updatePart = dentsData.filter((item, i) => {
        if (item.part === this.state.prePopulatePartName) {
          index = i;
        }
        return item.part === this.state.prePopulatePartName;
      });
      if (updatePart.length) {
        dentsData[index] = updatePart[0];
        this.setState({
          userEnteredDents: dentsData,
        });
      } else {
        this.setState({
          userEnteredDents: [
            // ...this.state.userEnteredDamages,
            // {
            ...this.state.dents,
            // },
          ],
        });
      }
    } else {
      this.setState({
        userEnteredDents: [
          // part : this.state.prePopulatePartName,
          ...this.state.dents,
        ],
      });
    }
  };
  getTotalDents = () => {
    const { Dents } = this.state.data;
    let totalDents =
      Dents &&
      Dents.reduce((acc, num) => parseInt(acc) + parseInt(num.TotalDents), 0);
    return totalDents;
  };
  updatePartDetail = async () => {
    const client = localStorage.getItem("client");
    await this.state.canvas.discardActiveObject().renderAll();
    var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
    var base64image = imageEditorCanvas[0].toDataURL("image/jpeg");
    // Validation here
    this.setState({ toggle_update_btn_loader: true });
    const Dents = this.state.data.Dents;
    let index;
    let updatePart = Dents.filter((item, i) => {
      if (item.Part === this.state.prePopulatePartName) {
        index = i;
      }
      return item.Part === this.state.prePopulatePartName;
    });
    await this.updateUserEnteredDents();
    updatePart[0].userEnteredDents = this.state.userEnteredDents;
    updatePart[0].TotalDents = this.state.dentsCount;
    if (
      client === "OTHER" ||
      client === "SWISS" ||
      client === "POLAND" ||
      client === "ROM"
    ) {
      updatePart[0].A = this.state.A;
      updatePart[0].B = this.state.B;
      updatePart[0].C = this.state.C;
    } else if (client === "CANADA" || client === "FR") {
      updatePart[0].A = this.state.A;
      updatePart[0].B = this.state.B;
      updatePart[0].C = this.state.C;
      updatePart[0].D = this.state.D;
    } else if (client === "US") {
      updatePart[0].A = this.state.A;
      updatePart[0].B = this.state.B;
      updatePart[0].C = this.state.C;
      updatePart[0].D = this.state.D;
      updatePart[0].E = this.state.E;
    } else if (client === "DNS") {
      updatePart[0].A = this.state.A + this.state.B + this.state.C;
    }
    Dents[index] = updatePart[0];
    const finalPostData = this.state.data;
    finalPostData.Dents = Dents;
    finalPostData.TotalDentCount = await this.getTotalDents();
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${true}`;
    let ImageUploadData = JSON.stringify({
      partnerId: localStorage.getItem("partnerId"),
      vin: localStorage.getItem("selectedFile"),
      base64image,
      imageName: this.imageName(),
    });
    // let ImageUploadData = new FormData();
    // ImageUploadData.append("partnerId", localStorage.getItem("partnerId"));
    // ImageUploadData.append("vin", localStorage.getItem("selectedFile"));
    // ImageUploadData.append("base64image", base64image);
    // ImageUploadData.append("imageName", this.imageName());
    let payload = {
      ...finalPostData,
      // userEnteredDamages : this.state.userEnteredDamages,
    };
    // if(this.state.prePopulatePartName === "Underbody"){
    //   finalPostData.Pass = false
    // }
    Axios.post(url, payload)
      .then((res) => {
        Axios.post(configuration.updateBase64, ImageUploadData)
          .then((res) => {
            if (res.data.success) {
              Toast.fire({
                type: "success",
                title: "Data saved successfully",
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.message) {
                alert(error.response.data.message);
                return;
              }
              alert("Something went wrong please try again later");
            }
          });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          alert("File does not exist. File could not be replaced.");
        } else {
          alert("Something went wrong please try again later");
        }
      })
      .finally(() => {
        this.setState({ toggle_update_btn_loader: false });
      });
  };

  getBase64Url = async () => {
    const partner_id = localStorage.getItem("partnerId");
    const vin_number = localStorage.getItem("selectedFile");
    let img_name;
    // if (this.props.location.state && this.props.location.state.url !== "") {
    //   // img_name = this.props.url.split("/")[6];
    //   this.setState({ extraPartName: img_name });
    // } else {
    // }
    img_name = this.props.history.location.pathname.split("/")[2];
    const response = await Axios.get(configuration.getBase64, {
      params: {
        partner_id,
        vin_number,
        img_name,
      },
    })
      .then()
      .catch((err) => {
        this.setState({
          ...this.state,
          loader: false,
          data64ImgError: true,
        });
      });
    if (response !== undefined) {
      this.setState({
        ...this.state,
        data64Url: response.data.base64_img,
        imageUrl: img_name,
        loader: false,
      });
    }
  };
  getPartDetails = async () => {
    const part = this.props.history.location.pathname.split("/")[2];
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.GetPartDetails +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId +
          "&part=" +
          part
      );
      //
      // console.table(response.data);
      let stringr = response.data.json;
      if (stringr) {
        let partarr = stringr && stringr.split("\r\n");
        let objArray = partarr.map((r) => {
          return r.split(" ");
        });

        this.setState({ partDetails: objArray });
      }

      //console.table(objArray);
    } else {
      this.props.history.push("/login");
    }
  };
  // handleChange function for dentSize and dentType
  handleChange = (e) => {
    const client = localStorage.getItem("client");
    const name = e.target.name;
    const value = e.target.value;
    const { isUpdate, selectedObjIndex, dents, canvas } = this.state;
    let dentSize;
    value === "D-Green"
      ? (dentSize = (client == "US" || client == "CANADA") ? 12 : 14)
      : value === "N-Yellow"
      ? (dentSize = (client == "US" || client == "CANADA") ? 14 : 21)
      : value === "Q-Orange"
      ? (dentSize = (client == "US" || client == "CANADA") ? 18 : 31)
      : value === "H-Pink"
      ? (dentSize = (client == "US" || client == "CANADA") ? 21 : 35)
      : value === "O-Red" && (dentSize = (client == "US" || client == "CANADA") ? 25 : 41);
    if (name === "dentSize") {
      dentSize = value;
    }
    if (!isUpdate) {
      this.setState({
        [name]: value,
        dentSize,
      });
    } else if (isUpdate) {
      dents[selectedObjIndex][name] = value;
      this.setState({
        [name]: value,
        dentSize,
        dents,
      });
      let allObjs = this.state.canvas.getObjects();
      for (let i in allObjs) {
        if (dents[selectedObjIndex].id === allObjs[i].id) {
          value === "D-Green"
            ? allObjs[i].set({ radius: 4, stroke: "#32CD32" })
            : value === "N-Yellow"
            ? allObjs[i].set({ radius: 7.5, stroke: "#FFFF00" })
            : value === "Q-Orange" &&
              allObjs[i].set({ radius: 11.5, stroke: "#FF0000" });
        }
      }
    }
  };
  // for update canvas
  // handleDentsChanges = (e, index) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   const { dents } = this.state;
  //   dents[index][name] = value;
  //   this.setState({
  //     dents,
  //   });
  //   let allObjs = this.state.canvas.getObjects();
  //   for (let i in allObjs) {
  //     if (dents[index].id === allObjs[i].id) {
  //       value === "A"
  //         ? allObjs[i].set("radius", 30)
  //         : value === "B"
  //         ? allObjs[i].set("radius", 50)
  //         : value === "C" && allObjs[i].set("radius", 80);
  //     }
  //   }
  // };
  handleButtonClick = (i, type) => {
    const { dents } = this.state;
    dents[i]["accepted"] = type === "Yes" ? true : false;
    this.setState({
      dents,
    });
  };

  // undo = () => {
  //   this.setState({
  //     option : "undo"
  //   })
  //   const {canvas,A,B,C,D,E,dentsCount,dentType} = this.state
  //   let countA = A, countB = B,countC = C,countD = D,countE = E;
  //     let undoArr = []
  //     if(canvas._objects.length > 0){
  //       if(canvas._objects[canvas._objects.length -1].text == "X"){
  //         let ObjId = canvas._objects[canvas._objects.length -1].id
  //         let indexAvl = canvas.getObjects().some(function(el) {
  //           return el.id === ObjId;
  //         })
  //         if(indexAvl){
  //           canvas.getObjects().forEach(function(o) {
  //             if(o.id === ObjId) {
  //               console.log(ObjId);
  //             console.log(o.id);
  //                 if(o.dentType === 'A' || dentType === "A"){
  //                   countA = A + 1
  //                 } else if(o.dentType === 'B' || dentType === "B"){
  //                   countB = B + 1
  //                 } else if(o.dentType === 'C' || dentType === "C") {
  //                   countC = C + 1
  //                 } else if(o.dentType === 'D' || dentType === "D") {
  //                   countD = D + 1
  //                 } else if(o.dentType === 'E' || dentType === "E") {
  //                   countE = E + 1
  //                 }
  //             }
  //             })
  //         }
  //           this.setState({
  //             A : countA,
  //             B : countB,
  //             C : countC,
  //             D : countD,
  //             E : countE,
  //             dentsCount : dentsCount + 1
  //           })
  //         undoArr.push(canvas._objects.pop());

  //         // canvas._objects
  //       } else if(canvas._objects[canvas._objects.length - 1].textType === 'objText'){
  //         if(canvas._objects[canvas._objects.length - 2].dentType === 'A'){
  //           this.setState({
  //             A : A - 1,
  //             dentsCount : dentsCount - 1
  //           })
  //         } else if(canvas._objects[canvas._objects.length - 2].dentType === 'B'){
  //           this.setState({
  //             B : B - 1,
  //             dentsCount : dentsCount - 1
  //           })
  //         } else if(canvas._objects[canvas._objects.length - 2].dentType === 'C'){
  //           this.setState({
  //             C : C - 1,
  //             dentsCount : dentsCount - 1
  //           })
  //         } else if(canvas._objects[canvas._objects.length - 2].dentType === 'D'){
  //           this.setState({
  //             D : D - 1,
  //             dentsCount : dentsCount - 1
  //           })
  //         } else if(canvas._objects[canvas._objects.length - 2].dentType === 'E'){
  //           this.setState({
  //             E : E - 1,
  //             dentsCount : dentsCount - 1
  //           })
  //          }
  //          undoArr.push(canvas._objects.pop());
  //          undoArr.push(canvas._objects.pop());
  //       } else {
  //         canvas._objects.pop()
  //       }
  //     }
  //     canvas.renderAll();
  //     this.setState({
  //       option : ""
  //     })
  // };

  // undo = () => {
  //   this.setState({ option: "undo" });

  //   const { canvas, A, B, C, D, E, dentsCount } = this.state;
  //   let countA = A,
  //     countB = B,
  //     countC = C,
  //     countD = D,
  //     countE = E;
  //   let undoArr = [];

  //   if (canvas._objects.length > 0) {
  //     const lastObject = canvas._objects[canvas._objects.length - 1];
  //     console.log(lastObject);
      
  //     if (lastObject.text === "X") {
  //       const ObjId = lastObject.id;
  //       const indexAvl = canvas.getObjects().some((el) => el.id === ObjId);
  //       if (indexAvl) {
  //         canvas.getObjects().forEach((o) => {
  //           if (o.id === ObjId) {
  //             switch (o.dentType) {
  //               case "A":
  //                 countA = A + 1;
  //                 break;
  //               case "B":
  //                 countB = B + 1;
  //                 break;
  //               case "C":
  //                 countC = C + 1;
  //                 break;
  //               case "D":
  //                 countD = D + 1;
  //                 break;
  //               case "E":
  //                 countE = E + 1;
  //                 break;
  //               default:
  //                 break;
  //             }
  //           }
  //         });
  //       }

  //       this.setState({
  //         A: countA,
  //         B: countB,
  //         C: countC,
  //         D: countD,
  //         E: countE,
  //         dentsCount: dentsCount + 1,
  //       });
  //       undoArr.push(canvas._objects.pop());
  //     } else if (lastObject.textType === "objText") {
  //       const secondLastObject = canvas._objects[canvas._objects.length - 2];

  //       switch (secondLastObject.dentType) {
  //         case "A":
  //           this.setState({ A: A - 1, dentsCount: dentsCount - 1 });
  //           break;
  //         case "B":
  //           this.setState({ B: B - 1, dentsCount: dentsCount - 1 });
  //           break;
  //         case "C":
  //           this.setState({ C: C - 1, dentsCount: dentsCount - 1 });
  //           break;
  //         case "D":
  //           this.setState({ D: D - 1, dentsCount: dentsCount - 1 });
  //           break;
  //         case "E":
  //           this.setState({ E: E - 1, dentsCount: dentsCount - 1 });
  //           break;
  //         default:
  //           break;
  //       }

  //       undoArr.push(canvas._objects.pop());
  //       undoArr.push(canvas._objects.pop());
  //     } else {
  //       canvas._objects.pop();
  //     }
  //   }

  //   canvas.renderAll();
  //   this.setState({ option: "" });
  // };

  undo = () => {
    this.setState({ option: "undo" });
    const client = localStorage.getItem("client");
  
    const { canvas, A, B, C, D, E, dentsCount } = this.state;
    let countA = A,
        countB = B,
        countC = C,
        countD = D,
        countE = E;
  
    if (canvas._objects.length > 0) {
      const lastObject = canvas._objects[canvas._objects.length - 1];
  
      if (lastObject.text === "X" && (client == "POLAND"&& this.state.is_remove_x)) {
        const ObjId = lastObject.id;
  
        const associatedObject = canvas.getObjects().find(o => o.id === ObjId);
  
        if (associatedObject) {
          switch (associatedObject.dentType) {
            case "D-Green":
              countA += 1;
              break;
            case "N-Yellow":
              countB += 1;
              break;
            case "Q-Orange":
              countC += 1;
              break;
            case "H-Pink":
              countD += 1;
              break;
            case "O-Red":
              countE += 1;
              break;
            default:
              break;
          }
  
          this.setState({
            A: countA,
            B: countB,
            C: countC,
            D: countD,
            E: countE,
            dentsCount: dentsCount + 1
          });
        }
        canvas._objects.pop();  
      } else if (
        lastObject.text === "X" && client !== "POLAND" 
      ) {
        const ObjId = lastObject.id;
  
        const associatedObject = canvas.getObjects().find(o => o.id === ObjId);
  
        if (associatedObject) {
          switch (associatedObject.dentType) {
            case "D-Green":
              countA += 1;
              break;
            case "N-Yellow":
              countB += 1;
              break;
            case "Q-Orange":
              countC += 1;
              break;
            case "H-Pink":
              countD += 1;
              break;
            case "O-Red":
              countE += 1;
              break;
            default:
              break;
          }
  
          this.setState({
            A: countA,
            B: countB,
            C: countC,
            D: countD,
            E: countE,
            dentsCount: dentsCount + 1
          });
        }
        canvas._objects.pop();  
      }
        else if (lastObject.textType === "objText") {
        const secondLastObject = canvas._objects[canvas._objects.length - 2];
  
        switch (secondLastObject.dentType) {
          case "D-Green":
            this.setState({ A: A - 1, dentsCount: dentsCount - 1 });
            break;
          case "N-Yellow":
            this.setState({ B: B - 1, dentsCount: dentsCount - 1 });
            break;
          case "Q-Orange":
            this.setState({ C: C - 1, dentsCount: dentsCount - 1 });
            break;
          case "H-Pink":
            this.setState({ D: D - 1, dentsCount: dentsCount - 1 });
            break;
          case "O-Red":
            this.setState({ E: E - 1, dentsCount: dentsCount - 1 });
            break;
          default:
            break;
        }
  
        canvas._objects.pop(); 
        canvas._objects.pop();
      } else {
        canvas._objects.pop();
      }
    }
  
    canvas.renderAll();
    this.setState({ option: "" });
  };
  

  handleColorChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    const {
      zoom,
      option,
      fontSize,
      textColor,
      inputVal,
      sizeOption,
      dentsOption,
      dentSize,
      dentType,
      dentsCount,
      prePopulatePartName,
      partName,
      data64Url,
      data64ImgError,
      A,
      B,
      C,
      D,
      E,
      blindColor,
      toggle_update_btn_loader,
      isPlasticTrue,
      clientName,
    } = this.state;
    const { orderNumber } = this.state.order;
    const isCoopClient =
      clientName && clientName.toLocaleLowerCase() == "coop" ? true : false;
    return (
      <>
        <Col xs="12" sm="12">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                    <Button
                      className="btn-danger mr-2"
                      onClick={() => this.props.history.goBack()}
                    >
                      {this.lang("Back")}
                    </Button>
                    <small>
                      {client === "SWISS" || client === "POLAND" ? (
                        <span>{this.lang("DashboardVIN")} : </span>
                      ) : (
                        <span>{this.lang("VIN Number")} : </span>
                      )}{" "}
                      {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                    {/* <div className="pull-right">
                    <small className="rightLbl">
                    <span>{this.lang("Order No")} :</span>&nbsp; {orderNumber}
                    </small>
                    <Link className="glass" to="/TabView">
                      <button className="btn btn-danger btn-sm">
                        <i className="fa fa-dot-circle-o"></i> {">>"}
                      </button>
                    </Link>

                    <Link className="glass" to="/vehicleDentInfo">
                      <button
                        style={{ marginRight: 10 }}
                        className="btn btn-danger btn-sm"
                      >
                        {"<<"} <i className="fa fa-dot-circle-o"></i>
                      </button>
                    </Link>
                  </div> */}
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <Card className="m-0">
            {/* <CardHeader>
              <Link className="glass" to="/TabView">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link>
              <Button
                className="btn-danger mr-2"
                onClick={() => this.props.history.goBack()}
              >
                {this.lang("Back")}
              </Button>
              <small className="pull-right rightLbl">
                Order No : {orderNumber}
              </small>
              <small>
                {" "}
                VIN Number : {localStorage.getItem("selectedFile")}
              </small>
            </CardHeader> */}
            <div className="imageEditor">
              <div className="mainContainer row text-center p-0">
                <TransformWrapper disabled={!zoom} z>
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                      <div className="row">
                        <div className="col-md-12 col-lg-12 col-sm-12 p-0 dent_editor_main">
                          <div className="row p-0 align-items-end">
                            <div className="col">
                              <FormGroup className="m-0">
                                <p className="highlight">
                                  {this.lang("dentType")}
                                </p>
                                <Input
                                  id="type_of_dent"
                                  name="dentType"
                                  onChange={(e) => this.handleChange(e)}
                                  value={dentType}
                                  type="select"
                                  disabled={isPlasticTrue}
                                >
                                  {dentsOption.map((option, i) => (
                                    <option value={option} key={i}>
                                      {option}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </div>
                            <div className="col">
                              <FormGroup className="m-0">
                                <p className="highlight">
                                  {this.lang("dentSize")}
                                </p>
                                <Input
                                  id="type_of_dent"
                                  name="dentSize"
                                  onChange={(e) => this.handleChange(e)}
                                  value={dentSize}
                                  type="number"
                                  min="0"
                                  disabled={isPlasticTrue}
                                ></Input>
                                {/* <Input
                                id="type_of_dent"
                                name="dentSize"
                                onChange={(e) => this.handleChange(e)}
                                value={dentSize}
                                type="select"
                              >
                                {["10", "20", "30", "40", "50", "60"].map(
                                  (option, i) => (
                                    <option value={option} key={i}>
                                      {option}
                                    </option>
                                  )
                                )}
                              </Input> */}
                              </FormGroup>
                            </div>
                            <div className="col">
                              <p className="highlight p-0">
                                {this.lang("Dent")}
                              </p>
                              <button
                                disabled={isPlasticTrue}
                                className={`btn Pencile-btn w-100  ${
                                  option === "circle" ? "active-tool" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    option: "circle",
                                    zoom: false,
                                    selection: true,
                                    strokeColor: "#FF0000",
                                  });
                                }}
                              >
                                <img src={Circle} />
                              </button>
                            </div>
                            <div className="col">
                              <p className="highlight p-0">
                                {this.lang("Dent")}_1
                              </p>
                              <button
                                disabled={isPlasticTrue}
                                className={`btn Pencile-btn w-100  ${
                                  option === "blind" ? "active-tool" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    option: "blind",
                                    zoom: false,
                                    selection: true,
                                    // strokeColor: "#FF0000",
                                  });
                                }}
                              >
                                {/* <img src={Circle} /> */}
                                <i
                                  className="fa fa-circle"
                                  style={{
                                    fontSize: "18px",
                                    color: blindColor,
                                  }}
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                            {option === "blind" && (
                              <div className="col color_selection">
                                <p className="highlight p-0">
                                  {this.lang("color")}
                                </p>
                                <input
                                  className={`btn Pencile-btn w-100  ${
                                    option === "blind" ? "active-tool" : ""
                                  }`}
                                  type="color"
                                  name="blindColor"
                                  value={blindColor}
                                  onChange={(e) => this.handleColorChange(e)}
                                  disabled={isPlasticTrue}
                                />
                              </div>
                            )}
                            <div className="col">
                              <p className="highlight p-0">
                                {this.lang("Remove")}
                              </p>
                              <button
                                disabled={isPlasticTrue}
                                className={`btn Pencile-btn w-100  ${
                                  option === "Remove" ? "active-tool" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    option: "Remove",
                                    zoom: false,
                                    selection: false,
                                    strokeColor: "red",
                                  });
                                }}
                              >
                                <img src={Remove} />
                              </button>
                            </div>
                            <div className="col">
                              <p className="highlight">{this.lang("Edit")}</p>
                              <button
                                disabled={isPlasticTrue}
                                className={`btn Pencile-btn w-100  ${
                                  option === "move" ? "active-tool" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    option: "move",
                                  });
                                }}
                              >
                                <img src={Edit} />
                              </button>
                            </div>
                            <div className="col">
                              <p className="highlight">{this.lang("Undo")}</p>
                              <button
                                disabled={isPlasticTrue}
                                className={`btn Pencile-btn w-100 
                                  ${option === "undo" ? "active-tool" : ""}`}
                                onClick={(e) => this.undo(e)}
                              >
                                <img src={Undo} />
                              </button>
                            </div>
                            <div className="col">
                              <p className="highlight p-0"> </p>
                              <Button
                                className="table_update_button"
                                outline
                                onClick={() => this.updatePartDetail()}
                                disabled={
                                  toggle_update_btn_loader || isPlasticTrue
                                }
                              >
                                {toggle_update_btn_loader ? (
                                  <Spinner style={{ height: '1rem', width: '1rem' }} size="sm" />
                                ) : (
                                  this.lang("Update")
                                )}
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-lg-9 col-sm-12 dent_editor_canvas_main">
                          <TransformComponent
                            wrapperStyle={{
                              width: "100%",
                              height: "100%",
                              // border: "2px dotted #d80707",
                              // borderRadius: "25px",
                              marginTop: "10px",
                            }}
                            contentStyle={{
                              width: "100%",
                              height: "100%",
                              justifyContent: "center",
                            }}
                          >
                            <div className="container display_dent_information">
                              <div className="row align-items-center p-0">
                                <div className="col-6 partsname text-left">
                                  <p>{this.lang(prePopulatePartName)}</p>
                                </div>
                                <div className="col-6 dentcount text-right">
                                  <p>
                                    {this.lang("Dents")} : {dentsCount}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <canvas
                              ref={this.cnavasRef}
                              id="canvas"
                              style={{
                                height: "100% !important",
                                width: "100% !important",
                              }}
                            />
                            {(data64ImgError || !data64Url) && (
                              <div className="row d-inline">
                                <h5 className="text-center">
                                  {this.lang("Image not found!")}
                                </h5>
                              </div>
                            )}
                          </TransformComponent>
                        </div>
                        <div className="col-md-12 col-lg-3 col-sm-12 mt-4 fabric_right_side_table_row p-0">
                          <DentEditorTable
                            lang={this.lang}
                            A={A}
                            B={B}
                            C={C}
                            D={D}
                            E={E}
                            dentsCount={dentsCount}
                            prePopulatePartName={prePopulatePartName}
                            isCoopClient={isCoopClient}
                          />
                        </div>
                        {/* <div className="col-md-12 col-lg-3 col-sm-12 mt-4 fabric_right_side_table_row p-0">
                          <table className="table table-striped table-responsive">
                            <thead>
                            <th scope="col" width="40%">{this.lang("Part")}</th>
                              <th scope="col" width="10%">{this.lang(client === "US" ? "DIME": "A")}</th>
                              <th scope="col" width="10%">{this.lang(client === "US" ? "NKL": "B")}</th>
                              <th scope="col" width="10%">{this.lang(client === "SWISS" || client === "POLAND" ? "UG" : client === "AUT" ? "time/h" : client === "US" ? "QTR": "C")}</th>
                              {client == "US" &&
                                <>
                                <th scope="col" width="10%">{this.lang("HALF")}</th>
                                <th scope="col" width="10%">{this.lang("OS")}</th>
                                </>
                              }
                              <th scope="col" width="30%" style={{wordBreak : "inherit", whiteSpace: "normal"}}>{this.lang("Total Dents")}</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td style={{wordBreak : "inherit", whiteSpace: "normal"}}>
                                      {this.lang(prePopulatePartName)}
                                  </td>
                                  <td>
                                      {A}
                                  </td>
                                  <td>
                                    {B}  
                                  </td>
                                  <td>
                                      {C}
                                  </td>
                                 {client == "US" && <>
                                  <td>
                                      {D}
                                  </td>
                                  <td>
                                      {E}
                                  </td>
                                 </>}
                                  <td>
                                      {dentsCount}
                                  </td>
                                </tr>
                            </tbody>
                          </table>

                          </div> */}
                      </div>
                    </>
                  )}
                </TransformWrapper>
              </div>
            </div>
          </Card>
        </Col>
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};

export default withRouter(connect(mapStateToProps)(DentEditor));
